<template>
  <div class="cert-drawer">
    <img v-if="img" :src="img" alt="" class="bg-img">
    <div class="btns">
      <div class="btn-item add-btn" @click="newMask">+</div>
      <div class="btn-item save-btn" @click="saveMasks">保存</div>
      <div class="btn-item preview-btn" @click="goPreview">预览</div>
    </div>

    <cert-mask :scale="scale"
               @delete="deleteMask(mask)"
               :data="mask"
               @edit="editMask(mask)"
               v-for="(mask,index) in masks"
               :key="'mask_' + index">
    </cert-mask>

    <el-dialog :close-on-click-modal="false"
               :visible.sync="maskFormVisiable"
               title="绘制内容"
               width="30%">
      <mask-form ref="mForm"
                 @cancel="maskFormVisiable = false"
                 :form="activedMask" @submit="submited">
      </mask-form>
    </el-dialog>
  </div>
</template>

<script>
  import CertMask from './CertMask';
  import MaskForm from './MaskForm';

  // 空标识
  const emptyMask = {
    field: '',
    x: 50,
    y: 0,
    type: 0,
    font_size: 20,
    align: 'center',
    color: '#333333',
    demo: '',
    img_width: 500,
    img_height: 500,
    width: 0,
    height: 0,
  };

  export default {
    name: 'CertCanvas',
    components: {
      CertMask,
      MaskForm,
    },
    props: ['cert', 'saveUrl', 'previewUrl'],
    data() {
      return {
        img: this.cert.template_url,
        masks: this.cert.template_options || [],
        activedMask: {},
        maskFormVisiable: false,
        scale: 1,
        src_width: 0,
        scr_height: 0,
        maxSort: 1,
      };
    },
    methods: {
      loading() {
        return new Promise((resovle) => {
          const loading = this.$loading({
            lock: true,
            text: 'Loading...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
          });
          resovle(loading);
        });
      },
      newMask() {
        this.maskFormVisiable = true;
        this.activedMask = {
          ...emptyMask,
          sort: (this.maxSort),
        };
        this.maxSort = this.maxSort + 1;
      },
      saveMasks() {
        this.loading().then((loading) => {
          axios.post(this.saveUrl, this.masks).then(function(response) {
            common.msg('success',response.data.message);
          }).catch(function(error) {
            common.msg('error', error.response.data.message);
          }).finally(() => loading.close());
        });
      },
      isDefaultMask(msk) {
        return !!msk.default;
      },
      deleteMask(msk) {
        if (this.isDefaultMask(msk)) {
          return;
        }
        const i = this.masks.findIndex(rec => rec === msk);
        if (i !== -1) {
          this.masks.splice(i, 1);
        }
      },
      editMask(fm) {
        this.activedMask = fm;
        if (this.$refs.mForm) {
          this.$refs.mForm.beforeOpen();
        }
        this.maskFormVisiable = true;
      },
      submited(fm) {
        if (!this.masks.find(rec => rec === fm)) {
          this.masks.push(fm);
        }
        this.activedMask = fm;
        this.maskFormVisiable = false;
      },
      goPreview() {
        this.loading().then((loading) => {
          axios.post(this.previewUrl, this.masks).then(function(response) {
            window.open(response.data.url);
          }).catch(function(error) {
            common.msg('error', error.response.data.message);
          }).finally(() => loading.close());
        });
      },
    },
    async mounted() {
      const img = new Image();
      img.src = this.cert.template_url;
      const that = this;

      img.onload = function load() {
        that.scale = 1140 / img.width;
        emptyMask.font_size = Math.round(24 / that.scale);
        emptyMask.y = Math.round(80 / that.scale);
        if (!that.cert.template_options || !that.cert.template_options.length) {
          that.masks = [
            {
              ...emptyMask,
              default: true,
              field: 'name',
              demo: '张三',
              sort: 0,
            }];
        }
        that.src_width = img.width;
        that.scr_height = img.height;
      };
    },
  };
</script>

<style lang="scss" scoped>
  .cert-drawer {
    position: relative;
    overflow: hidden;
    width: 1140px;
    font-size: 0;
    margin: 0 auto;
    .bg-img {
      width: 1140px;
      user-select: none;
      -webkit-user-drag: none;
    }
  }

  .btns {
    background: rgba(255, 255, 255, 0.6);
    padding: 10px;
    font-size: 14px;
    position: absolute;
    top: 5px;
    left: 5px;
    z-index: 2;
    display: flex;
    .btn-item {
      user-select: none;
      cursor: pointer;
      padding: 5px 10px;
      border: 2px dashed;
      color: #666;
      margin-right: 3px;
      font-weight: bolder;
      &:hover {
        color: #333;
      }
    }
  }
</style>
